module.exports = __webpack_public_path__ + "img/tpc-22.3045cb12.webp";